import { Card, Icon, Shelf, Stack, Text } from '@chaser/components';

const MAX_CUSTOMERS = 20;

export const groupSkippedByContact = (skipped = []) => {
  const byContact = new Map();

  skipped.forEach(({ contactID, invoiceNumber }) => {
    const key = contactID ?? 'unknown';
    if (!byContact.has(key)) {
      byContact.set(key, { contactID: key, invoiceNumbers: [] });
    }
    byContact.get(key).invoiceNumbers.push(invoiceNumber);
  });

  return [...byContact.values()];
};

const SkippedInvoicesWarning = ({ skippedCount, skipped }) => {
  if (!skippedCount || !skipped?.length) {
    return null;
  }

  const groups = groupSkippedByContact(skipped);
  const visibleGroups = groups.slice(0, MAX_CUSTOMERS);
  const remainingCustomers = groups.length - visibleGroups.length;

  return (
    <Card appearance="secondary" p="small" backgroundColor="Light Neutral 2" borderColor="transparent">
      <Shelf gap="small" alignItems="flex-start">
        <Icon name="warning-circle" size="20" color="Orange AA" />
        <Stack gap="xsmall">
          <Text fontWeight="bold">
            {skippedCount} {skippedCount === 1 ? 'invoice' : 'invoices'} weren&apos;t imported — their
            customer isn&apos;t in Chaser yet. Add these customers to your contacts and re-upload:
          </Text>
          <Stack gap="xsmall" as="ul" role="list">
            {visibleGroups.map(({ contactID, invoiceNumbers }) => (
              <Text key={contactID} as="li" color="Mid Neutral 1">
                Customer {contactID}: {invoiceNumbers.filter(Boolean).join(', ')}
              </Text>
            ))}
          </Stack>
          {remainingCustomers > 0 && (
            <Text color="Mid Neutral 1">
              …and {remainingCustomers} more {remainingCustomers === 1 ? 'customer' : 'customers'}
            </Text>
          )}
        </Stack>
      </Shelf>
    </Card>
  );
};

export default SkippedInvoicesWarning;
